import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core'
import { MatDialog, MatDialogConfig } from '@angular/material/dialog'
import { MatPaginator } from '@angular/material/paginator'
import { MatSort } from '@angular/material/sort'
import { MatTableDataSource } from '@angular/material/table'
import { Subject, takeUntil } from 'rxjs'
import { AyBService } from 'src/app/services/api/ayb.service'
import Swal from 'sweetalert2'
import { DialogProveedoresComponent } from './dialog-proveedores/dialog-proveedores.component'
@Component({
  selector: 'app-ver-proveedores',
  templateUrl: './ver-proveedores.component.html',
  styleUrls: ['./ver-proveedores.component.scss']
})
export class VerProveedoresComponent implements OnInit, OnDestroy {
  private _unsubscribeOnDestroy$: Subject<boolean> = new Subject<boolean>()

  dishes: any = []
  displayedColumns: string[] = [
    'id',
    'nombreComercial',
    'razonSocial',
    'provincia',
    'distrito',
    'direccionSocial',
    'documento',
    'ruc',
    'telefono',
    'ccDolares',
    'ccSoles',
    'modificar',
    'eliminar'
  ]

  dataSource = new MatTableDataSource<any>()
  isLoading: boolean = true

  paginator!: MatPaginator
  @ViewChild(MatPaginator) set matPaginator (paginator: MatPaginator) {
    this.paginator = paginator
    this.dataSource.paginator = paginator
  }

  sort!: MatSort
  @ViewChild(MatSort, { static: false }) set matSort (sort: MatSort) {
    this.sort = sort
    this.dataSource.sort = sort
  }

  constructor (
    public dialog: MatDialog,
    private readonly alimentosService: AyBService
  ) {}

  ngOnInit () {
    this.getAllProveedores()
    this.dataSource = new MatTableDataSource()
  }

  ngOnDestroy (): void {
    this._unsubscribeOnDestroy$.next(true)
    this._unsubscribeOnDestroy$.complete()
  }

  getAllProveedores () {
    this.alimentosService
      .queryGetAllProvider()
      .pipe(takeUntil(this._unsubscribeOnDestroy$))
      .subscribe(response => {
        console.log(response)
        this.dishes = response.getAllProvider
        this.dataSource.data = this.dishes
        this.dataSource.paginator = this.paginator
        this.isLoading = false
      })
  }

  applyFilter (event: Event) {
    const filterValue = (event.target as HTMLInputElement).value
    this.dataSource.filter = filterValue.trim().toLowerCase()
  }

  openDialog (element: any = null): void {
    let dialogConfig = new MatDialogConfig()

    if (element == null) {
      dialogConfig.data = {
        id: '',
        codigoProveedor: '',
        cuentaContableDolares: '',
        cuentaContableSoles: '',
        direccionSocial: '',
        distrito: '',
        documento: '',
        nombreComercial: '',
        provincia: '',
        razonSocial: '',
        ruc: '',
        telefono: '',
        title: 'Agregar Proveedor',
        estado: 2
      }
    } else {
      dialogConfig.data = {
        id: element.id,
        codigoProveedor: element.codigoProveedor,
        cuentaContableDolares: element.cuentaContableDolares,
        cuentaContableSoles: element.cuentaContableSoles,
        direccionSocial: element.direccionSocial,
        distrito: element.distrito,
        documento: element.documento,
        nombreComercial: element.nombreComercial,
        provincia: element.provincia,
        razonSocial: element?.razonSocial,
        ruc: element.ruc,
        telefono: element.telefono,

        title: 'Modificar Proveedor',
        estado: 1
      }
    }

    dialogConfig.width = '40rem'
    //dialogConfig.height="30rem";

    let dialogRef = this.dialog.open(DialogProveedoresComponent, dialogConfig)

    dialogRef
      .afterClosed()
      .pipe(takeUntil(this._unsubscribeOnDestroy$))
      .subscribe(result => {
        if (result == 1) {
          this.getAllProveedores()
        }
      })
  }

  deleteSKU (element: any): void {
    Swal.fire({
      title: '¿Estás seguro de que quieres borrar este registro?',
      showCancelButton: true,
      confirmButtonText: 'Sí',
      cancelButtonText: 'No'
    }).then(result => {
      if (result.isConfirmed) {
        this.alimentosService
          .mutationDeleteProvider(element.id)
          .pipe(takeUntil(this._unsubscribeOnDestroy$))
          .subscribe(data => {
            console.log(data)
            this.getAllProveedores()
          })
        Swal.fire({
          position: 'top-end',
          icon: 'success',
          title: 'El registro se eliminó satisfactoriamente.',
          showConfirmButton: false,
          timer: 4000
        })
      }
    })
  }
}
